import { Usps as UspsBase } from "@omni/components/components/Blocks/usps/usps";
import { useProductPageContext } from "@omni/components/components/ProductPage/context/productPage.context";
import { cn } from "@omni/utils/styles";

import { UspsComponent } from "@/components/Product/ProductPage/components/usps/usps.component";

type Props = {
    className?: string;
};

export const Usps = ({ className }: Props) => {
    const { usps } = useProductPageContext();

    return (
        <UspsBase
            usps={usps}
            className={cn(
                "tw:border tw:border-tertiary tw:rounded-xl tw:p-4",
                "tw:md:border-none tw:md:bg-grey",
                className
            )}
        >
            <UspsComponent />
        </UspsBase>
    );
};
